import { AxiosError } from 'axios';

/**
 * Wraps Axios errors for RTK Query error handling
 * Extracts the error details from the response data
 */
export const wrapError = (err: AxiosError | any) => {
  if (err.isAxiosError) {
    const e = err as AxiosError;
    return {
      error: (e.response?.data as any)?.error
    };
  }

  return {
    error: err?.message ?? err
  };
};
